import { Volume } from '@/api/type-server'

/**
 * Get the effective quota for a volume based on expiration state.
 * When expired, returns last_quota_gb (preserved quota before expiration).
 * When active, returns quota_gb (current allocated quota).
 */
export function getEffectiveQuota(vol: Volume, isExpired: boolean): number {
  if (isExpired) return vol.last_quota_gb || 0
  return vol.quota_gb || 0
}

export function volumeUsage(vol: Volume, isExpired: boolean = false) {
  const usageInGb = vol.usage_mb / 1024
  return {
    usage: usageInGb === 0 ? '0' : usageInGb.toFixed(3),
    total: getEffectiveQuota(vol, isExpired),
    unit: 'GB',
  }
}
